<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="no-rain">
<h1>No Rain</h1>
<p style="text-indent: 00em;">As the sun slowly fades and day turns into night</p>
<p style="text-indent: 00em;">The sky turns into a vivid delight</p>
<p style="text-indent: 00em;">The birds quieten down and the temperature cools</p>
<p style="text-indent: 00em;">And the frogs start calling in what’s left of the pools</p>
<p style="text-indent: 00em;">Because the temperature has been so high</p>
<p style="text-indent: 00em;">All that one can do is hydrate and sigh</p>
<p style="text-indent: 00em;">But the rain will come again one day soon</p>
<p style="text-indent: 00em;">I think it has something to do with the moon</p>
<p style="text-indent: 00em;">Then maybe we can sleep well again</p>
<p style="text-indent: 00em;">As the temperature drops with the arrival of rain</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?7ef832c0